<template>
  <a-modal
    v-model:open="open"
    width="1000px"
    centered
    :footer="false"
    :closable="false"
    :destroyOnClose="true"
    wrapClassName="xmov-empty-modal"
    @cancel="close"
  >
    <TemplateDetail />
    <CloseOutlined :class="CloseIconOutClass" @click="close" />
  </a-modal>
</template>

<script lang="ts" setup>
import { TemplateDetail } from './detail'
import { CloseIconOutClass } from '~/hooks/useModal/modals/closeIcon'
const open = useTemplateVisible()

const close = () => {
  useTemplateCancel()
}
</script>
